import {Box, Chip, Stack, Typography} from "@mui/material";

function AddressCard({address, countries = []}) {
  const country = countries.find(c => c.id === address.countryId);
  const state = country?.states?.find(s => s.id === address.stateProvinceId);

  return (
    <Box
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        padding: 2,
        backgroundColor: '#fff',
        mt: 2,
      }}
    >
      <Stack spacing={0.5}>
        {address.streetAddress1 && (
          <Typography variant="body1">{address.streetAddress1}</Typography>
        )}
        {address.streetAddress2 && (
          <Typography variant="body1">{address.streetAddress2}</Typography>
        )}
        <Typography variant="body1">
          {[address.postalCode, address.city].filter(Boolean).join(' ')}
          {state ? `, ${state.name}` : ''}
        </Typography>
        {country && (
          <Typography variant="body1">{country.name}</Typography>
        )}
        {address.isBilling && (
          <Chip
            label="Billing address"
            size="small"
            sx={{alignSelf: 'flex-start', mt: 1}}
            color="primary"
            variant="outlined"
          />
        )}
      </Stack>
    </Box>
  );
}

export default AddressCard;
